import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const questions = ['¿Cómo abro mi cuenta bancaria?', '¿Qué es el Annual Report y cuándo lo presento?', '¿Necesito un Operating Agreement?', '¿Qué estructura elegir?', '¿Cómo cumplir con el IRS?', '¿Qué necesitas para operar correctamente?'];
export function PainSection() {
  return <section className="relative overflow-hidden" data-id="element-304">
      {/* BLOCK 1 — Hero Statement */}
      <div className="py-20 md:py-24 bg-white" data-id="element-305">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-306">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="text-center" data-id="element-307">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold leading-tight mb-6" style={{
            WebkitTextStroke: '0',
            textShadow: 'none'
          }} data-id="element-308">
              <span className="text-[#6B21A8]" style={{
              WebkitTextStroke: '0',
              textShadow: 'none'
            }} data-id="element-309">
                Registrar una empresa es&nbsp;fácil.
              </span>
              <br data-id="element-310" />
              <span className="text-[#6B21A8] italic" style={{
              WebkitTextStroke: '0',
              textShadow: 'none'
            }} data-id="element-311">
                Crearla bien es otra&nbsp;historia.
              </span>
            </h2>

            <p className="text-gray-600 font-light text-lg md:text-xl max-w-2xl mx-auto mb-8" data-id="element-312">
              Todos los días emprendedores latinos dan el paso. Registran
              su&nbsp;LLC. Obtienen su&nbsp;EIN. Sienten que ya
              están&nbsp;listos.
            </p>

            <div className="w-20 h-0.5 bg-inkova-accent mx-auto mb-8" data-id="element-313"></div>

            <p className="text-inkova-primary font-bold text-xl md:text-2xl font-serif" data-id="element-314">
              Y entonces llega la&nbsp;realidad:
            </p>
          </motion.div>
        </div>
      </div>

      {/* BLOCK 2 — FAQ Cards */}
      <div className="py-16 md:py-20 bg-[#F8F8F8]" data-id="element-315">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-316">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center text-inkova-accent font-bold text-sm uppercase tracking-widest mb-10" data-id="element-317">
            Preguntas que nadie te&nbsp;responde
          </motion.p>

          <div className="space-y-4" data-id="element-318">
            {questions.map((q, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.08
          }} className="bg-white rounded-xl shadow-sm border-l-4 border-inkova-primary flex items-center px-5 py-4 gap-4 hover:shadow-md transition-shadow cursor-default" data-id="element-319">
                <span className="text-inkova-primary text-xl flex-shrink-0" data-id="element-320">
                  ❓
                </span>
                <p className="text-gray-900 font-semibold text-sm md:text-base flex-grow" data-id="element-321">
                  {q}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>

      {/* BLOCK 3 — Closing Impact */}
      <div className="py-16 md:py-20 bg-[#5a4579]" data-id="element-322">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-323">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="text-center" data-id="element-324">
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-serif font-bold text-white mb-4" data-id="element-325">
              Tener una LLC no es tener un&nbsp;negocio.
            </h3>
            <p className="text-inkova-accent italic text-lg md:text-xl font-serif mb-8" data-id="element-326">
              Es solo el primer&nbsp;paso.
            </p>
            <a href="#planes" className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-inkova-accent text-inkova-primary font-bold text-base md:text-lg hover:bg-white transition-colors duration-300 shadow-lg" data-id="element-327">
              Quiero hacerlo bien desde el&nbsp;inicio
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}